<template>
	<div>
		<!-- Add offer Button -->
		<div v-if="!computedOfferId">
			<p>Offer does not exist, please add an offer</p>
			<div class="flex xs-row">
				<j-button
					v-for="(item, i) in productIdOptions"
					:key="i"
					class="mt3 mr2"
					@click="handleAdd(item)"
					>{{ `Add ${t(item.plan)}` }}</j-button
				>
			</div>
		</div>

		<!-- Offer view -->
		<div v-else>
			<component :is="componentToRender" class="mt6" />
			<!-- Delete Offer Button -->
			<div class="flex xs-right mt12">
				<j-button type="error" @click="handleDelete">Delete Offer</j-button>
			</div>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

import JBOffers from "./JB/JBOffers"
import EXOffers from "./EX/EXOffers"

export default {
	components: {
		JButton,

		JBOffers,
		EXOffers
	},

	props: {
		productIdOptions: {
			type: Array,
			default: () => []
		},
		componentToRender: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			selectedProductId: null
		}
	},

	methods: {
		t(key) {
			const locale = {
				"en-US": {
					jewellers_block_primary_layer_hkd:
						"Jewellers Block Primary Layer HKD",
					jewellers_block_primary_layer_usd:
						"Jewellers Block Primary Layer USD",
					jewellers_block_excess_layer_hkd: "Jewellers Block Excess Layer HKD",
					jewellers_block_excess_layer_usd: "Jewellers Block Excess Layer USD",
					jewellers_block_open_market_hkd: "Jewellers Block Open Market HKD",
					jewellers_block_open_market_usd: "Jewellers Block Open Market USD",
					jewellers_exhibition_primary_layer:
						"Jewellers Exhibition Primary Layer",
					jewellers_exhibition_excess_layer: "Jewellers Exhibition Excess Layer"
				},
				"zh-HK": {}
			}
			return locale[this.$store.state.settings.locale][key]
		},

		async handleAdd(productId) {
			console.log(productId)
			this.selectedProductId = productId
			await this.addOffer()
			this.fetchProposal()
		},

		async handleDelete() {
			await this.deleteOffer()
			this.fetchProposal()
		},

		async addOffer(productId) {
			const query = gql`
				mutation addOfferToProposal(
					$caseId: String!
					$proposalId: String!
					$input: addOfferInput!
				) {
					addOfferToProposal(
						caseId: $caseId
						proposalId: $proposalId
						input: $input
					) {
						status
						errors
						createdStatus {
							id
						}
					}
				}
			`

			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				proposalId: this.$store.state.caseManagement.proposalId,
				input: {
					productId: this.selectedProductId
				}
			}

			const res = await api({
				query,
				variables
			})

			if (res?.data?.addOfferToProposal?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.addOfferToProposal?.errors?.[0] ||
						res?.errors?.[0]?.message ||
						this.$t("errors.general")
				)
				return Promise.resolve(res)
			}

			return Promise.resolve(res)
		},

		async deleteOffer() {
			const query = gql`
				mutation removeOfferFromProposal(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
				) {
					removeOfferFromProposal(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
					) {
						status
						errors
					}
				}
			`

			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				proposalId: this.$store.state.caseManagement.proposalId,
				offerId: this.computedOfferId
			}

			const res = await api({
				query,
				variables
			})

			if (res?.data?.removeOfferFromProposal?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.removeOfferFromProposal?.errors?.[0] ||
						res?.errors?.[0]?.message ||
						this.$t("errors.general")
				)
				return Promise.resolve(res)
			}

			return Promise.resolve(res)
		},

		async fetchProposal() {
			await this.$store.dispatch("caseManagement/fetchProposals", {
				caseId: this.$store.state.caseManagement.caseId
			})
		}
	},

	computed: {
		computedOfferId() {
			const arrayOfIds = this.productIdOptions?.map(product => {
				return this.$store.state.caseManagement.proposals
					?.find(
						proposal =>
							proposal?.id === this.$store.state.caseManagement.proposalId
					)
					?.basket?.find(
						item => item.product?.productId?.plan === product?.plan
					)?.id
			})

			return arrayOfIds?.find(item => item)
		}
	},

	watch: {
		computedOfferId: {
			handler() {
				this.$store.commit("caseManagement/SET_OFFER_ID", this.computedOfferId)
			},
			immediate: true
		}
	}
}
</script>
